import Vue from 'vue/dist/vue.common';
import { apolloProvider } from "../vue-apollo-init";
import gql from 'graphql-tag';
import _ from 'lodash';
import postQuery from './../gql/post_query.graphql';

export class Article_Item_List {
    constructor(){
        this.vue_element = false;        
    }
    init(){
        let store = window.store;
        let router = window.router;

        this.vue_element = new Vue({
            apolloProvider,
            apollo: {
              posts: {
                //, taxQuery: {taxArray: {taxonomy: POSTAUTHOR, field: TAXONOMY_ID, operator: IN, terms: ["18"]}, relation: AND}
                query() {
                  let where_query = `{search: $posts_search_text}`;
                  if(this.posts_tags){
                    //where: {tagIn: "11"}
                    where_query = `{search: $posts_search_text, tagIn: ${this.posts_tags.tag_id} }`;
                  } else if(this.posts_cats.length){
                    //where_query = `{search: $posts_search_text, taxQuery: {taxArray: [{taxonomy: POSTAUTHOR, field: TAXONOMY_ID, operator: IN, terms: ["18"]}, {taxonomy: POSTCOLLABORATOR, field: TAXONOMY_ID, operator: IN, terms: ["15"]}], relation: OR}}`
                    let cats_query = '[' + this.posts_cats.reduce(function(prevVal,currVal,idx){
                      return idx == 0 ? '{taxonomy: ' + currVal.taxonomy + ', field: TAXONOMY_ID, operator: IN, terms: ["' + currVal.terms + '"] ' + '}': prevVal + ', ' + '{taxonomy: ' + currVal.taxonomy + ', field: TAXONOMY_ID, operator: IN, terms: ["' + currVal.terms + '"] ' + '}';
                    }, '') + ']';
                    where_query = `{search: $posts_search_text, taxQuery: {taxArray: ${cats_query}, relation: AND}}`;
                    //console.log(where_query);
                  }
                  //console.log(`where: ${where_query}`);
                  return gql`query getPosts($article_items_next_page: String, $posts_search_text: String) {
                  posts (first: 5, after: $article_items_next_page, where: ${where_query}) {
                    pageInfo {
                      hasNextPage
                      endCursor
                    }
                    nodes {
                      id
                      content
                      contentTypeName
                      link
                      uri
                      title
                      date
                      excerpt
                      postFields {
                        articlePhoto {
                          id
                          sourceUrl(size: CONTENT_WIDTH_HALF)
                          srcSet(size: CONTENT_WIDTH_HALF)
                          sizes(size: CONTENT_WIDTH_HALF)
                          altText
                          mediaDetails {
                            width
                            height
                          }
                        }
                      }                      
                      tags {
                        nodes {
                          id
                          databaseId
                          name
                        }
                      }
                      postLocations {
                          nodes {
                            id
                            databaseId
                            name
                          }
                      }
                      postCollaborators {
                          nodes {
                            id
                            databaseId
                            name
                          }
                      }
                      postTopics {
                          nodes {
                            id
                            databaseId
                            name
                          }
                      }
                      postAuthors {
                        nodes {
                          id
                          databaseId
                          name
                        }
                      }              
                    }
                  }
                }`
                },
                /*update (data) {
                  return data.posts;
                },*/
                variables() {
                  return {
                    posts_next_page: null,
                    posts_search_text: store.state.posts_search_text,
                    posts_cats: store.state.posts_cats,
                    posts_tag: store.state.posts_tag,
                  }
                },
                result ({ data }) {
                  //console.log(data);
                },
              }
            },
            el: '#article-item-list',
            template: '#article-item-list-template',
            data: store.state,
            updated: function () {
              this.$nextTick(function () {
                router.updatePageLinks();
                for(let node of store.state.posts.nodes) {
                  this.$apolloProvider.defaultClient.query({
                    query: postQuery,
                    variables: { post_uri: node.uri }
                  })

                }
              })
            },
            methods: {
              loadMore() {
                if(this.posts.pageInfo.hasNextPage){
                  //this.article_items_next_page = this.posts.pageInfo.endCursor;
                  this.$apollo.queries.posts.fetchMore({
                    variables: { 
                      article_items_next_page: this.posts.pageInfo.endCursor, 
                      first: 5
                    },
                    updateQuery: function(existing, incoming) {
                      //console.log(incoming);
                      return ({                      
                        posts: {
                          __typename:"RootQueryToPostConnection", 
                          nodes: [...existing.posts.nodes, ...incoming.fetchMoreResult.posts.nodes],
                          pageInfo: incoming.fetchMoreResult.posts.pageInfo
                        } 
                        })
                    }
    
                  })
                } else {
                  //console.log('end of list');
                }
              },
              set_tag(tag_id, tag_title) {
                store.setTag({tag_id: tag_id, tag_title: tag_title});
              },
              is_tag_active(tag_id, tag_title) {
                if(this?.posts_tags?.tag_id){
                  return tag_id == this.posts_tags.tag_id;
                } else {
                  return false;
                }
              },
              set_cat(cat_id, cat_type){
                store.setCat(cat_id, cat_type);
              },
              is_cat_active(cat_id, cat_type) {
                return _.some(this.posts_cats, {taxonomy: cat_type, terms: cat_id})
              }
            },
          })

      window.articleItemList = this.vue_element;
    }
}